module.exports = __webpack_public_path__ + "95cdf204aa3e78e7518577d5f68bd1fa.png";